var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"outContainer"},[_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"微信充电用户"}},[_c('wechatChargeUser')],1),_c('el-tab-pane',{attrs:{"label":"卡充电用户"}},[_c('cardUser')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }